import { gql } from "@stadium/services/apollo-client/server";

export const fetchStoresCategories = gql`
  query marketingCategories(
    $onlyEnabled: Boolean
    $atleastOneLiveStore: Boolean
    $includeRestrictions: [String!]
  ) {
    marketingCategories(
      onlyEnabled: $onlyEnabled
      atleastOneLiveStore: $atleastOneLiveStore
      includeRestrictions: $includeRestrictions
    ) {
      id
      name
      description
      slug
    }
  }
`;

// This query will be fired using axios - (fetching from apolloClient causing 504 issue on Server side) so we dont have to wrap it with gql
export const fetchCurrentStoreCategory = `
  query marketingCategory($slug: String!) {
    marketingCategory(slug: $slug) {
      metaTitle
      metaDescription
    }
  }
`;
